import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  template: `
    <h2 class="m-0"><strong>{{data.head}}</strong></h2>
    <hr class="my-2">
    <div class="content-wrap mb-4">
        <p [innerHtml]="data.body.replace('##',
         data.item? '<strong>'+data.item+'</strong>': 'this item')"></p>
   </div>
    <ng-container> <!-- -->
      <button type="submit" mat-flat-button color="primary" (click)="close(true)">Yes</button>
      <button type="button" mat-stroked-button color="warn" (click)="close(false)">No</button>
    </ng-container>
    <ng-container *ngIf="data.info">
      <button type="button" mat-flat-button color="primary" (click)="close(false)">Ok</button>
    </ng-container>
    <!-- <ng-container *ngIf="data.other">
      <mat-form-field class="w-100">
        <mat-label>Other Category Name</mat-label>
        <input matInput #other required>
      </mat-form-field>
      <button type="button" mat-flat-button color="primary" (click)="submit(other.value)">Submit</button>
    </ng-container> -->
  `,
  styles: ['h2{text-transform: capitalize;}','h4{margin-top:0;margin-bottom:1rem}', 'button{margin-right:10px;background: #123c88; border: 0; padding: 4px 18px; color: #fff; border-radius: 25px 25px; }', ]
})
export class ConfirmationDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data

  ) { }
  close(type: boolean) {
    this.dialogRef.close(type);
  }
  submit(val) {
    this.dialogRef.close(val);
  }


}
